import gmx_zMixins         from '../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support

import lmx_localData            from '../primitives/localData'
import lmx_LocalValues          from './set_LocalValues'

import lmx_watching             from './watching'
import lmx_events               from './Events'

import lmx_draw_Forms           from './draw_Forms'
import lmx_draw_Menus           from './draw_Menus'
import lmx_draw_ChartCanvas     from './draw_ChartCanvas'
import lmx_draw_Charts          from './draw_Charts'
import lmx_draw_Timeline        from './draw_Timeline'

import lmx_draw_Legends         from './draw_Legends'
import lmx_draw_Milestone       from './draw_Milestone'




export default {
  
  mixins: [
    gmx_zMixins, 
    
    // Local Mixins
    lmx_localData,
    lmx_LocalValues,
    lmx_watching,
    lmx_events,

    lmx_draw_Forms,
    lmx_draw_Menus,
    lmx_draw_ChartCanvas,
    lmx_draw_Charts,
    lmx_draw_Timeline,
    lmx_draw_Legends,
    lmx_draw_Milestone,

  ],

}
